import { useTranslation } from 'react-i18next'
import clsx from 'clsx'

import { AvatarCell, AvatarSize, SelectDropdown } from '@makyoapp/makyo-ui'

interface UserDropdownOption {
  id: string
  email: string
  name: string
  photo: string
}

export interface UserDropdownV2Props {
  user?: string
  setUser: (user: string) => void
  options: UserDropdownOption[]
  className?: string
  toggleClassName?: string
  noDefaultToggleStyle?: boolean
  outlined?: boolean
}

export function UserDropdownV2({
  user,
  setUser,
  options,
  className,
  toggleClassName,
  noDefaultToggleStyle = false,
  outlined = false,
}: UserDropdownV2Props) {
  const { t } = useTranslation()

  const userOptions: UserDropdownOption[] = [
    {
      id: '',
      email: '',
      name: t('Guest'),
      photo: '',
    },
    ...options,
  ]

  const selected = userOptions.find((opt) => opt.id === user)

  return (
    <SelectDropdown
      toggleClassName={clsx(noDefaultToggleStyle !== true && 'min-w-[200px] py-1! text-m-sm', toggleClassName)}
      outlined={outlined}
      className={className}
      withSearch={true}
      options={userOptions}
      value={selected}
      onChange={(opt, e) => {
        setUser(opt.id)
      }}
      optionLabel={(opt) => {
        return [opt.name, opt.email].join(' ')
      }}
      renderOption={(opt, inToggle) => {
        if (inToggle) {
          return (
            <AvatarCell
              fallbackError
              size={AvatarSize.XS}
              src={opt.photo}
              textClassName='txt'
              {...opt}
              renderTitle={(title) => {
                if (title === 'Guest') {
                  return t('{{name}}', {
                    name: title,
                  })
                }
                return t('Viewing as {{name}}', {
                  name: title,
                })
              }}
            />
          )
        } else {
          return (
            <AvatarCell
              fallbackError
              src={opt.photo}
              size={AvatarSize.XS}
              {...opt}
              renderTitle={(title) => {
                if (title === 'Guest') {
                  return t('{{name}}', {
                    name: title,
                  })
                }
                return title
              }}
            />
          )
        }
      }}
      windowed
    />
  )
}
